import script from "./BottomSearch2.vue?vue&type=script&setup=true&lang=js"
export * from "./BottomSearch2.vue?vue&type=script&setup=true&lang=js"

import "./BottomSearch2.vue?vue&type=style&index=0&id=3d7c52d6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d7c52d6"]])

export default __exports__